'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' });

var Store = function Store(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Store = (0, _pure2.default)(Store);
Store.muiName = 'SvgIcon';

exports.default = Store;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Store.js
// module id = 2896
// module chunks = 0